<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>路由管理</el-breadcrumb-item>
        <el-breadcrumb-item>路由列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <hx-table-result :show-pager-on-one-page="false">
      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="project" align="center" label="依属项目">
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="editItem(scope.row.id)">
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        { id: 1, project: "服务加" },
        { id: 2, project: "老干局" }
      ]
    };
  },
  methods: {
    editItem(id) {
      this.$router.push({
        name: "routeDetail",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
